module.exports = __webpack_public_path__ + "static/media/mpl-logo-simple.a32d4e8a.png";